import { TableColumn } from "react-data-table-component";
import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { MoreVertical } from "react-feather";
import { Link } from "react-router-dom";
import { InVoiceColumnType } from "../../../types/users/UserTypes";
import { showWarningAlert } from "../../../utils/showWarningAlert";
import { ProductListTableProductName } from "../../organization/OrganizationList";


const InvoiceAction: React.FC<{ row: InVoiceColumnType }> = ({ row }) => {
  const { t } = useTranslation();

  const handleCancelInvoice = () => {
    showWarningAlert({
      title: t("Are you sure?"),
      text: `Do you want to Cancel Invoice ${row.organizationName}?`,
      confirmButtonText: t("Confirm"),
      onConfirm: () => {
        // Block logic here
      },
    });
  };

 

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="span" className="cursor-pointer">
        <MoreVertical size={18} />
      </DropdownToggle>
      <DropdownMenu>
     
        
          
          <Link to={`${process.env.PUBLIC_URL}/billingpayments/invoice/view/${row.id}`}>
          <DropdownItem>{t("View")}</DropdownItem>
          </Link>
        
          <Link to={`${process.env.PUBLIC_URL}/billingpayments/invoice/edit/${row.id}`}>
          <DropdownItem>{t("Edit")}</DropdownItem></Link>
       
        <DropdownItem onClick={handleCancelInvoice}>{t("CancelInvoice")}
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export const InvoiceListColumn = (t: TFunction): TableColumn<any>[] => [
  {
    name: t("Sl.No"),
    selector: (row) => row.id,
    sortable: true,
    width: "100px",
  },
  {
    name: t("OrganizationName"),
    cell: (row) => (
      <ProductListTableProductName image={row.image} name={row.organizationName} />
    ),
    sortable: true,
    grow: 2,
  },
  {
    name: t("Date"),
    selector: (row) => row.date,
    sortable: true,
  },
  {
    name: t("DueDate"),
    selector: (row) => row.duedate,
    sortable: true,
  },
  {
    name: t("Amount"),
    selector: (row) => row.amount,
    sortable: true,
  },
  {
    name: t("Action"),
    cell: (row) => <InvoiceAction row={row} />,
    sortable: true,
  },
];
